
import cotizacion from './cotizacion';
import factura from './factura';
import factura_v2 from './factura_v2';
import recibo from './recibo';

const template = {
	factura: [ factura, factura_v2 ],
	cotizacion,
	cobro: recibo,
	recibo
}

export default template;

